export const getFilenameFromUrl = (url: string): string => {
  // Note: split() on any string always yields a non-empty array, so pop() always
  // returns a value here — the fallback only satisfies TS's array typing.
  return url.split('/').pop() ?? url
}
